import AdyenCheckout from '@adyen/adyen-web';
import api from '@utils/api';
import analyticsMoncler from './analytics';
import analyticsStone from '@stone/utils/analytics';
import { getId } from './brandDiffsUtils';
const cardremap = {
    visa: 'Visa',
    mc: 'Mastercard',
    amex: 'Amex',
    maestro: 'Maestro',
};
const paymentutils = {
    supportedpayments: [
        'scheme',
        'paypal',
        'alipay',
        'amazonpay',
        'wechatpayQR',
        'klarna_account',
        'klarna',
        'klarna_paynow',
        'ideal',
        'paywithgoogle',
        'directEbanking',
        'applepay',
        'eps',
        'Adyen_Pay_By_Link',
        'Adyen_Pay_In_Store',
        'kcp_creditcard',
        'econtext_online',
        'kcp_banktransfer',
        'kcp_payco',
        'kcp_naverpay',
        'cashondelivery',
        'plafond',
        'kakaopay',
        'affirm',
    ],
    filteredpayments: ['cup', 'wechatpayMiniProgram', 'wechatpayWeb', 'amazonpay', 'wechatpaySDK', 'samsungpay', 'paynow'],
    filteredmbm: ['cashondelivery', 'kcp_banktransfer', 'econtext_online'],
    appallowed: [
        'scheme',
        'paypal',
        'applepay',
        // 'alipay',
        'klarna_account',
        'klarna',
        'klarna_paynow',
        'ideal',
        // 'directEbanking',
        'eps',
        // 'bankTransfer_IBAN',
        'kcp_creditcard',
        'kcp_banktransfer',
        'kcp_payco',
        'kcp_naverpay',
    ],
    redirectpayments: [
        'alipay',
        'applepay',
        'wechatpayWeb',
        'klarna',
        'klarna_account',
        'klarna_paynow',
        'directEbanking',
        'bankTransfer_IBAN',
        'kcp_creditcard',
        'kcp_banktransfer',
        'kcp_payco',
        'kcp_naverpay',
        'wechatpayQR',
        'kakaopay',
    ],
    getRedirectPaymentByCurrentSession: () => {
        return window.isiDeal2Active ? ['ideal'] : [];
    },
    remapBrand: function (brand) {
        return cardremap[brand] || brand;
    },
    paymentFromComponent: async function (statedata, component) {
        console.log('paymentFromComponent');
        await api
            .adyenPaymentFromComponent(statedata, statedata.paymentMethod.type)
            .then((data) => {
            console.info('log adyenPaymentFromComponent response:', data);
            if (data.orderNo) {
                document.querySelector('#merchantReference').value = data.orderNo;
            }
            if (data.fullResponse && data.fullResponse.action) {
                console.info('component.handleAction');
                component.handleAction(data.fullResponse.action);
            }
            else if (data.decision == 'REFUSED') {
                if (component) {
                    component.setStatus('ready');
                }
                document.querySelector('#showConfirmationForm').submit();
            }
        })
            .catch((e) => {
            console.error(e);
            // setErrors([e]);
        });
    },
    getAdyenCheckout: async function (adyenConfig, order, adyenPaymentMethods, express, setValue, setValid, orderID, orderToken) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let amount = order.totals.totalAmount * 100;
        if ((_a = order.totals.giftCards) === null || _a === void 0 ? void 0 : _a.totalAmount) {
            amount = (order.totals.totalAmount - order.totals.giftCards.totalAmount) * 100;
            console.log('GIFTCARD TOTAL INCLUDED IN CALCULATION', amount);
        }
        // console.log('ORDER:', order)
        let adyenCheckout;
        let affirmoptions = {
            visibility: {
                personalDetails: 'hidden',
                billingAddress: 'hidden',
                deliveryAddress: 'hidden',
            },
        };
        let googlepayoptions = {
            environment: adyenConfig.environment,
            onAuthorized: (data) => {
                // console.log('google onAuthorized ' + JSON.stringify(data, null, 2));
            },
            onClick: (resolve, reject) => {
                // console.log('google onClick');
                if (!express) {
                    if (getId() === 'MO') {
                        analyticsMoncler.paymentInfo('googlepay', order.items, order.totals.totalAmount);
                    }
                    else if (getId() === 'ST') {
                        analyticsStone.checkout(order, 'payment', 'googlepay');
                    }
                }
                resolve();
            },
            onSubmit: async (e, component) => {
                console.log('googlepay onsubmit ' + JSON.stringify(e, null, 2));
                setValid && setValid(e.isValid);
                console.log('submitpayment');
                document.getElementById('form-submitpayment').dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                console.log('submitpayment done');
            },
            // For version 3.13.0 and later
            // You no longer need to specify values for required fields like gatewayMerchantId and merchantId. The Component takes the values from the /paymentMethods response. However, if you specify the optional field merchantName, then you must also specify merchantId and gatewayMerchantId.
            // configuration: {
            //   gatewayMerchantId: adyenConfig.merchantAccount,
            //   merchantId: adyenConfig.googleMerchantID,
            //   merchantName: 'Moncler',
            // },
            showPayButton: true,
            buttonType: 'plain',
            buttonColor: 'black',
        };
        if (express) {
            googlepayoptions.transactionInfo = {
                currencyCode: order.currencyCode,
                countryCode: window.country,
                totalPrice: order.totals.totalAmount.toString(),
                totalPriceStatus: 'ESTIMATED',
            };
            googlepayoptions.totalPriceStatus = 'ESTIMATED';
            googlepayoptions.shippingAddressRequired = true;
            googlepayoptions.emailRequired = true;
            googlepayoptions.billingAddressRequired = true;
            googlepayoptions.shippingAddressParameters = {
                phoneNumberRequired: true,
                allowedCountryCodes: [window.country],
            };
            googlepayoptions.shippingOptionParameters = {
                defaultSelectedOptionId: (_d = (_c = (_b = order === null || order === void 0 ? void 0 : order.shipping) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.selectedShippingMethod) === null || _d === void 0 ? void 0 : _d.ID,
                shippingOptions: (_f = (_e = order === null || order === void 0 ? void 0 : order.shipping) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.applicableShippingMethods.filter((m) => !m.storePickupEnabled).map((m) => {
                    return {
                        id: m.ID,
                        label: `${m.displayName} ${m.shippingCost}`,
                        description: m.description || '-',
                    };
                }),
            };
            googlepayoptions.callbackIntents = ['SHIPPING_ADDRESS', 'PAYMENT_AUTHORIZATION', 'SHIPPING_OPTION']; //
            googlepayoptions.shippingOptionRequired = true;
            googlepayoptions.paymentDataCallbacks = {
                onPaymentDataChanged: (intermediatePaymentData) => {
                    console.info('google onPaymentDataChanged ', intermediatePaymentData);
                    return api.expressGooglepayDataChange(intermediatePaymentData);
                },
                onPaymentAuthorized: (data) => {
                    console.info('google onPaymentAuthorized ', data);
                    return api.expressGooglepayAuthorize(data);
                },
            };
        }
        //  console.info('googlepayoptions: ' + JSON.stringify(googlepayoptions, null, 2));
        const applepayoptions = {
            configuration: {
                merchantName: 'Adyen Test merchant', // Required for Component versions earlier than 3.17.1. Name to be displayed on the form.
            },
            buttonType: 'plain',
            buttonColor: 'black',
            onValidateMerchant: (resolve, reject, validationURL) => {
                console.log('applepay onValidateMerchant');
                // not used, replaced by sfcc support
            },
            onChange: (state, component) => {
                console.log('applepay onChange');
                // not used, replaced by sfcc support
            },
        };
        const paypaloptions = {
            environment: adyenConfig.environment,
            style: {
                layout: 'vertical',
                color: order.orderDetail ? 'black' : 'white',
                shape: 'rect',
                label: 'paypal',
                height: 36,
            },
            intent: 'authorize',
            showPayButton: true,
            blockPayPalPayLaterButton: !adyenConfig.showPaypalPayLaterButton,
            onSubmit: (state, component) => {
                console.log('paypal onsubmit');
                paymentutils.paymentFromComponent(Object.assign(Object.assign({}, state.data), { orderID, orderToken }), component);
            },
            onCancel: (data, component) => {
                // data example: {"orderID":"EC-4FM95720TR8777224"} -> paypal order number
                console.log('paypal onCancel ' + document.querySelector('#merchantReference').value + ' ' + JSON.stringify(data));
                paymentutils.paymentFromComponent({ paymentMethod: { type: 'paypal' }, cancelTransaction: true }, component);
            },
            onError: (error, component) => {
                console.log('paypal onError');
                if (component) {
                    component.setStatus('ready');
                }
                document.querySelector('#showConfirmationForm').submit();
            },
            onAdditionalDetails: (state) => {
                console.log('paypal onAdditionalDetails');
                document.querySelector('#additionalDetailsHidden').value = JSON.stringify(state.data);
                document.querySelector('#showConfirmationForm').submit();
                return false;
            },
            onClick: () => {
                console.log('paypal onClick');
                if (!express) {
                    if (getId() === 'MO') {
                        analyticsMoncler.paymentInfo('paypal', order.items, order.totals.totalAmount);
                    }
                    else if (getId() === 'ST') {
                        analyticsStone.checkout(order, 'payment', 'paypal');
                    }
                }
                // (formref.current as any).dispatchEvent(new Event('submit'));
            },
        };
        const cardoptions = {
            enableStoreDetails: adyenConfig.showStoreDetails,
            hasHolderName: true,
            holderNameRequired: true,
            minimumExpiryDate: new Date(),
            styles: {
                base: {
                    color: 'black',
                    fontSize: '14px',
                    fontSmoothing: 'antialiased',
                    fontFamily: getId() === 'MO' ? 'MonclerGothic' : 'inherit',
                },
                error: {
                    color: '#a80000',
                },
                placeholder: {
                    color: '#999999',
                },
                validated: {},
            },
            onBrand: function onBrand(brandObject) {
                setValue('cardType', brandObject.brand);
            },
            onFieldValid: function onFieldValid(data) {
                if (data.endDigits) {
                    setValue('cardNumber', '************' + data.endDigits);
                }
            },
        };
        let amazonpayconfig = adyenPaymentMethods.paymentMethods.find((p) => p.type == 'amazonpay');
        let amazonpayoptions;
        if (amazonpayconfig) {
            let restrictions = {};
            restrictions[window.country] = {};
            amazonpayoptions = {
                buttonColor: 'LightGray',
                configuration: {
                    merchantId: (_g = amazonpayconfig === null || amazonpayconfig === void 0 ? void 0 : amazonpayconfig.configuration) === null || _g === void 0 ? void 0 : _g.merchantId,
                    storeId: (_h = amazonpayconfig === null || amazonpayconfig === void 0 ? void 0 : amazonpayconfig.configuration) === null || _h === void 0 ? void 0 : _h.storeId,
                    publicKeyId: (_j = amazonpayconfig === null || amazonpayconfig === void 0 ? void 0 : amazonpayconfig.configuration) === null || _j === void 0 ? void 0 : _j.publicKeyId,
                },
                deliverySpecifications: {
                    addressRestrictions: {
                        type: 'Allowed',
                        restrictions: restrictions,
                    },
                },
                // @ts-ignore
                currency: order.currencyCode,
                environment: adyenConfig.environment,
                // onSubmit: (state: any, component: AmazonPayElement) => {
                //   console.log('amazonpay onsubmit default');
                // },
            };
        }
        // locale: undefined, // Supported values: en_GB, de_DE, fr_FR, it_IT, es_ES
        // storeId: undefined, //	Retrieve this value from Amazon Pay Integration Central.
        const configuration = {
            locale: window.locale,
            environment: adyenConfig.environment,
            clientKey: adyenConfig.clientKey,
            paymentMethodsResponse: adyenPaymentMethods,
            onChange: (state, component) => {
                var _a;
                state.isValid; // True or false. Specifies if all the information that the shopper provided is valid.
                state.data; // Provides the data that you need to pass in the `/payments` call.
                // console.info('handleonchange state=', state, '\n', 'component ' + component);
                if (window.isiDeal2Active &&
                    state &&
                    state.data &&
                    ((_a = state.data.paymentMethod) === null || _a === void 0 ? void 0 : _a.type) === 'ideal' &&
                    state.errors &&
                    Object.keys(state.errors).length === 1 &&
                    state.errors.issuer === null) {
                    setValid && setValid(true);
                }
                else {
                    setValid && setValid(state.isValid);
                }
            },
            onAdditionalDetails: (state, component) => {
                state.data; // Provides the data that you need to pass in the `/payments/details` call.
                console.info('handleOnAdditionalDetails state: ', state, '\n', 'component: ', component);
                api.adyenPaymentDetails(state.data).then((data) => {
                    console.info('paymentDetails result: ', data);
                    if (data.action) {
                        console.info('Calling handleAction after payment details with ', data.action);
                        // component.handleAction(data.action);
                        const threeDSConfiguration = {
                            size: '05',
                            // Set to any of the following:
                            // '02': ['390px', '400px'] -  The default window size
                            // '01': ['250px', '400px']
                            // '03': ['500px', '600px']
                            // '04': ['600px', '400px']
                            // '05': ['100%', '100%']
                        };
                        adyenCheckout.createFromAction(data.action, threeDSConfiguration).mount('#threedscontainer');
                    }
                    else {
                        console.info('paymentDetails submit');
                        document.querySelector('#showConfirmationForm').submit();
                        // "data": {
                        //   "additionalData": {
                        //     "recurringProcessingModel": "CardOnFile"
                        //   },
                        //   "pspReference": "863620072379033F",
                        //   "resultCode": "Authorised",
                        //   "refusalReasonCode": "0",
                        //   "merchantReference": "dev15-00017511"
                        // }
                    }
                });
            },
            onSubmit: (e) => {
                console.info('default onsubmit', e);
                setValid && setValid(e.isValid);
            },
            amount: {
                value: amount,
                currency: order.currencyCode,
            },
            paymentMethodsConfiguration: {
                card: cardoptions,
                paywithgoogle: googlepayoptions,
                applepay: applepayoptions,
                paypal: paypaloptions,
                amazonpay: amazonpayoptions,
                affirm: affirmoptions,
            },
        };
        if (adyenConfig && adyenConfig.translations) {
            configuration.translations = adyenConfig.translations;
        }
        return await AdyenCheckout(configuration);
    },
};
export default paymentutils;
